import React from 'react'

import { Router } from 'react-router-dom'
import { Route, Switch } from 'react-router'
import { createBrowserHistory } from 'history'

import Home from './Home/HomePage'
import Content from './Content/ContentPage'
import AboutUs from './AboutUs/AboutUsPage'
import Privacy from './Privacy/PrivacyPage'
import Services from './Services/ServicesPage'

const history = createBrowserHistory()

history.listen(function(location) {
  window.gtag('config', window.GA_TRACKING_ID, {
    page_path: location.pathname,
  })
})

class RouterComponent extends React.Component {
  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/content" component={Content} />
          <Route exact path="/aboutus" component={AboutUs} />
          <Route exact path="/services" component={Services} />
          <Route exact path="/privacy" component={Privacy} />
        </Switch>
      </Router>
    )
  }
}

export default RouterComponent



// WEBPACK FOOTER //
// ./src/Pages/Router.js